import Vue from 'vue';

// Domain
import {
  CustomerOverviewStateManager,
} from '@/modules/home-dashboard/customer-overview/domain/state/customer-overview-state-manager';
import CustomerOverviewState
  from '@/modules/home-dashboard/customer-overview/domain/state/customer-overview-state';
import Injectable from '@/modules/shared/domain/di/injectable';
import Observer from '@/modules/shared/domain/observer/observer';

@Injectable()
export class CustomerOverviewVueStateManager
implements CustomerOverviewStateManager {
  private _state: CustomerOverviewState = Vue.observable<CustomerOverviewState>(
    new CustomerOverviewState(),
  );

  private readonly observers: Observer[] = [];

  get state(): CustomerOverviewState {
    return this._state;
  }

  set state(value: CustomerOverviewState) {
    this._state = value;
    this.notifyAll();
  }

  patch(state: Partial<CustomerOverviewState>) {
    type Keys = keyof CustomerOverviewState;
    Object.entries(state).forEach(([key, value]) => {
      const accessor = key as Keys;

      if (value !== undefined) {
        // eslint-disable-next-line
        // @ts-ignore @typescript-eslint/ban-ts-ignore
        this.state[accessor] = value;
      }
    });
  }

  notifyAll() {
    this.observers.forEach((observer) => observer.notify());
  }

  register(observer: Observer) {
    this.observers.push(observer);
  }
}
